import React from 'react'
import PropTypes from 'prop-types'
import cx from 'classnames'
import { formatPrice } from 'common/helpers'

import Message from 'components/text/Message/Message'
import VisuallyHidden from 'components/ui/VisuallyHidden/VisuallyHidden'

import s from './CrossedPrice.scss'
import messages from './messages'


const CrossedPrice = ({ className, price }) => {
  price = price || formatPrice(1495, true)

  return (
    <del className={cx(s.crossedPrice, className)}>
      <VisuallyHidden>
        <Message text={messages.text} />
      </VisuallyHidden>
      {price}
    </del>
  )
}

CrossedPrice.propTypes = {
  className: PropTypes.string,
  price: PropTypes.string,
}


export default CrossedPrice
